import * as React from 'react';
import { IFrame } from '@grandvisionhq/common';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsIframe = ({ component  })=>{
    const { iframe: content  } = component.getModels();
    if (!content) {
        return null;
    }
    const { source , scrolling , height , position , title  } = content;
    if (!title) {
        console.error(`Cannot render iframe without a 'title'. Please update configuraton for iframe with source: ${source}`);
        return null;
    }
    return /*#__PURE__*/ React.createElement(IFrame, {
        source: source,
        scrolling: scrolling,
        height: height,
        position: position,
        title: title
    });
};
var CmsIframe$1 = compose(withBreakpointVisibility, withHidableContent, withAnchor)(CmsIframe);

export { CmsIframe, CmsIframe$1 as default };
//# sourceMappingURL=Iframe.js.map
